const roles = {
  ADMIN: 'admin',
  DELIVERY: 'delivery',
  STORE: 'store'
}

const roleLabels = {
  ADMIN: 'Admin',
  DELIVERY: 'Delivery',
  STORE: 'Store'
}

const roleSelectOptions = [
  { text: roleLabels.ADMIN, value: roles.ADMIN },
  { text: roleLabels.DELIVERY, value: roles.DELIVERY },
  { text: roleLabels.STORE, value: roles.STORE }
]

export default {
  roles,
  roleLabels,
  roleSelectOptions
}
